import { useAppSelector } from '@/store/store-hooks'
import { RootState } from '@/store/store'
import { selectConversationSelectedFilesContentExpanded } from '@/chat-common/store/chat-ux.selectors'
import { selectFilesIsOverTokenLimit } from '@/chat-common/selected_files/store/selectors'
import SelectedFilesControl from '@/chat-common/selected_files/components/SelectFilesControl'
import SelectedFilesContent from '@/chat-common/selected_files/components/SelectedFilesContent'
import {
  selectAgentConversationFormHasErroredUserFiles,
  selectAgentConversationFormHasProcessingUserFiles,
  selectAgentConversationFormPendingUploads,
  selectAgentConversationFormShowFilesResetNotice,
} from '@/agent/chat_form/store/selectors'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'

type ChatControlsAssistantProps = {
  conversationId: string
}

export default function ChatControlsAssistant({ conversationId }: ChatControlsAssistantProps) {
  const isExpanded = useAppSelector((state: RootState) => selectConversationSelectedFilesContentExpanded(state, { chatId: conversationId }))

  const selectedFilesExceedsLimit = useAppSelector((state: RootState) =>
    selectFilesIsOverTokenLimit(state, {
      chatId: conversationId,
    })
  )
  const hasProcessingUserFiles = useAppSelector((state: RootState) => selectAgentConversationFormHasProcessingUserFiles(state, { conversationId }))
  const hasErroredUserFiles = useAppSelector((state: RootState) => selectAgentConversationFormHasErroredUserFiles(state, { conversationId }))
  const pendingUploadClientCount = useAppSelector((state: RootState) => selectAgentConversationFormPendingUploads(state, { conversationId }).length)

  const newFilesUxEnabled = kGetFeatureFlagStatus(kFeatureFlags.NEW_FILES_UX)
  const showFilesResetNotice = useAppSelector((state: RootState) => selectAgentConversationFormShowFilesResetNotice(state, { conversationId }))
  const showLegacyFilesResetNotice = newFilesUxEnabled && showFilesResetNotice

  return (
    <div>
      <div className={'flex flex-wrap items-end gap-x-2 gap-y-2 justify-end mt-1 mb-3'}>
        <SelectedFilesControl
          chatId={conversationId}
          isOverLimit={selectedFilesExceedsLimit}
          hasProcessingUserFiles={hasProcessingUserFiles}
          hasErroredUserFiles={hasErroredUserFiles}
          pendingFilesCount={pendingUploadClientCount}
          showLegacyFilesResetNotice={showLegacyFilesResetNotice}
        />
      </div>
      {isExpanded && (
        <SelectedFilesContent chatId={conversationId} isOverLimit={selectedFilesExceedsLimit} showLegacyFilesResetNotice={showLegacyFilesResetNotice} />
      )}
    </div>
  )
}
